/* ver 1.0 */

import * as THREE from "three";

export function ObjectTools(unify) {
  this.enableShadows = obj => {
    obj.traverse(function(node) {
      if (node instanceof THREE.Mesh) {
        node.castShadow = true;
      }
    });
  };

  this.disableShadows = obj => {
    obj.traverse(function(node) {
      if (node instanceof THREE.Mesh) {
        node.castShadow = false;
      }
    });
  };

  this.setColorHex = (obj, colorHex) => {
    obj.traverse(function(node) {
      if (node instanceof THREE.Mesh) {
        node.material.color.setHex(colorHex);
      }
    });
  };

  this.setColorRGB = (obj, colorRGB) => {
    obj.traverse(function(node) {
      if (node instanceof THREE.Mesh) {
        node.material.color.setRGB(colorRGB);
      }
    });
  };

  this.setMaterials = (obj, material) => {
    obj.traverse(function(node) {
      if (node.isMesh) {
        node.material = material;
      }
    });
  };

  // -----------------------------------------------------------------------------------
  // Deep Clone
  // -----------------------------------------------------------------------------------

  // Deep Clone
  this.deepClone = (model, cloneMaterials) => {
    if (model != null) {
      const anims = model.animations ? model.animations : null;

      // in case model is GLTF
      if (model.hasOwnProperty("scene")) model = model.scene;

      // Clone Object
      const clone = model.clone(true);
      const skinnedMeshes = {};

      model.traverse(node => {
        if (node.isSkinnedMesh) {
          skinnedMeshes[node.name] = node;
        }
      });

      const cloneBones = {};
      const cloneSkinnedMeshes = {};

      clone.traverse(node => {
        if (node.isBone) {
          cloneBones[node.name] = node;
        }

        if (node.isSkinnedMesh) {
          cloneSkinnedMeshes[node.name] = node;
        }
      });

      for (let name in skinnedMeshes) {
        const skinnedMesh = skinnedMeshes[name];
        const skeleton = skinnedMesh.skeleton;
        const cloneSkinnedMesh = cloneSkinnedMeshes[name];

        const orderedCloneBones = [];

        for (let i = 0; i < skeleton.bones.length; ++i) {
          const cloneBone = cloneBones[skeleton.bones[i].name];
          orderedCloneBones.push(cloneBone);
        }

        cloneSkinnedMesh.bind(new THREE.Skeleton(orderedCloneBones, skeleton.boneInverses), cloneSkinnedMesh.matrixWorld);
      }

      // Materials
      if (cloneMaterials) {
        model.traverse(node => {
          if (node.isMesh) {
            node.material = node.material.clone();
          }
        });
      }

      // Clone Animation
      if (anims != null) {
        if (anims.length > 0) {
          // animation mixer
          let mixer = new THREE.AnimationMixer(clone);
          clone.userData.mixer = mixer;
          clone.userData.animations = {};

          // clips
          anims.forEach(clip => {
            let newAction = mixer.clipAction(clip);
            clone.userData.animations[clip.name] = newAction;
          });
        }
      }

      return clone;
    } else {
      console.warn("Deep Clone: Model not found.");
    }
  };
}
